import { CatalogueisDuplicatedStatusType, CatalogueStatusType } from './types';

export const statusOptions: CatalogueStatusType[] = ['Active', 'Inactive'];

export const isDuplicatedOptions: CatalogueisDuplicatedStatusType[] = ['dublicated', 'notDublicated'];
